import { lazy, useState } from "react";

import Suspense from "components/shared/Suspense";

import ToggleSidebarButton from "./components/ToggleSidebarButton";

const MobileUserNavSidepanelActive = lazy(
  () => import("./MobileUserNavSidepanelActive"),
);

export default function MobileUserNavSidepanel() {
  const [clicked, setClicked] = useState(false);

  // Don't load Headless UI and the entire dropdown component unless it's clicked on
  if (clicked) {
    return (
      <Suspense fallback={<ToggleSidebarButton loading />}>
        <MobileUserNavSidepanelActive />
      </Suspense>
    );
  }

  return <ToggleSidebarButton onClick={() => setClicked(true)} />;
}
